// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__13y3h","emails":"CreateEditClinics_emails__d1Jfg","emailTagLabel":"CreateEditClinics_emailTagLabel__1LTbz"};